<div class="grid">
    <div class="col-12">
        <div class="card">
            <div class="flex justify-content-center mt-3" *ngIf="loading">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            <div class="p-fluid p-formgrid grid" *ngIf="itemProdutoVw && !loading">
                <div class="col-12 pt-5 px-5">
                    <div class="grid card-simple">
                        <div class="col-12 md:col-8">
                            <div class="grid">
                                <div class="col-12 md:col-6">
                                    <label class="label-superior">Descrição</label>
                                    <label class="label-inferior">
                                        {{ itemProdutoVw.descricao }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-4">
                                    <label class="label-superior">Grupo</label>
                                    <label class="label-inferior">
                                        {{ itemProdutoVw.descricaoGrupo }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Comissão</label>
                                    <label class="label-inferior">
                                        {{ itemProdutoVw.comissaoVenda | porcentagemFormat }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-3">
                                    <label class="label-superior">Valor Venda</label>
                                    <label class="label-inferior">
                                        {{ itemProdutoVw.valorVenda | currency: "BRL" }}
                                    </label>
                                </div>
                                <div class="col-12 sm:col-6 md:col-4">
                                    <label class="font-semibold">Custo Total</label>
                                    <label class="block">
                                        {{ custoTotal | percent: "1.2-2" }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="font-semibold text-lg">Frete</label>
                                    <label class="block">
                                        {{ percentualFrete / 100 | percent: "1.2-2" }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-3">
                                    <label class="font-semibold text-lg">Lucro Atual</label>
                                    <label class="block">
                                        {{ percentualLucroObtidoAtual | percent: "1.2-2" }} |
                                        {{ valorLucroObtidoAtual | currency: "BRL" }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-3">
                                    <label class="label-superior">Estoque Atual</label>
                                    <label class="label-inferior">
                                        {{ itemProdutoVw.estoqueAtual }}
                                        {{ itemProdutoVw.descricaoUnidadeMedida }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-3">
                                    <label class="label-superior">Controla Estoque</label>
                                    <div class="label-inferior">
                                        <label
                                            class="product-badge status-instock"
                                            id="controlaEstoque"
                                            *ngIf="itemProdutoVw.controlaEstoque"
                                        >
                                            SIM
                                        </label>
                                        <label
                                            class="product-badge status-outofstock"
                                            id="controlaEstoque"
                                            *ngIf="!itemProdutoVw.controlaEstoque"
                                        >
                                            NÃO
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-12 md:col-4 flex justify-content-start md:justify-content-end align-items-center"
                        >
                            <qrcode
                                *ngIf="itemProdutoVw.urlDetalheProduto; else exibirMsgSemQrCode"
                                class="cursor-pointer"
                                pTooltip="Ver dados"
                                [qrdata]="itemProdutoVw.urlDetalheProduto"
                                [width]="180"
                                [errorCorrectionLevel]="'M'"
                                (click)="abrirUrlProduto()"
                                imageSrc="../assets/images/logo_qrcode.png"
                            ></qrcode>
                            <ng-template #exibirMsgSemQrCode>
                                <div
                                    class="card h-full w-full flex align-content-center align-items-center"
                                >
                                    <span class="text-center">SEM QRCODE CADASTRADO</span>
                                </div>
                            </ng-template>
                        </div>
                        <div class="col-12">
                            <div class="grid">
                                <div class="col-12">
                                    <p-divider class="w-full"></p-divider>
                                </div>
                                <div class="field col-12 sm:col-4">
                                    <label class="text-lg">Novo Valor</label>
                                    <p-inputNumber
                                        name="novoValorServico"
                                        mode="currency"
                                        currency="BRL"
                                        locale="pt-BR"
                                        [allowEmpty]="true"
                                        [required]="true"
                                        [(ngModel)]="novoValor"
                                        (onInput)="calcularLucroObtido($event.value)"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 sm:col-2">
                                    <label class="text-lg font-semibold">Lucro Obtido</label>
                                    <label class="block" *ngIf="novoValor > 0">
                                        <span
                                            class="product-badge bg-green-600 admihair-text-white"
                                            *ngIf="valorLucroObtido >= valorLucroDesejado"
                                        >
                                            {{ valorLucroObtido | currency: "BRL" }}
                                        </span>
                                        <span
                                            class="product-badge bg-red-600 admihair-text-white"
                                            *ngIf="valorLucroObtido < valorLucroDesejado"
                                        >
                                            {{ valorLucroObtido | currency: "BRL" }}
                                        </span>
                                    </label>
                                    <label class="block" *ngIf="novoValor <= 0">
                                        {{ valorLucroObtido | currency: "BRL" }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
